import React, {useState} from "react";

import { graphql } from "gatsby";

import { Trans, useTranslation, useI18next } from 'gatsby-plugin-react-i18next';

import api from "../utils/api";

import {useFormik} from "formik";
import {TextInput} from "@mantine/core";

import ErrorMessage from "../components/ErrorMessage";
import Section from "../components/Section";
import Layout from "../components/Layout";

import appGoogleImg from "../images/appGoogle.jpg";
import appStoreImg from "../images/appStore.jpg";
import { isRtlLanguage } from "../utils/rtl";

const Forgot = (props) => {
	const { t } = useTranslation();
    const { language } = useI18next(); 
	const isRtl = isRtlLanguage(language);
	const [error, setError] = useState("");
	const [successfulSending, setSuccessfulSending] = useState(false);

	const validate = (values) => {
		const errors = {};
		if (!values.email) {
			errors.email = t("forgot_form_errors_no_username");
		} else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
			errors.email = t("forgot_form_errors_invalid_email");
		}

		return errors;
	};

	const formik = useFormik({
		initialValues: {
			email: "",
		}, validate: validate, validateOnChange: false, onSubmit: (values) => {
			setSuccessfulSending(false);
			const validationRes = validate(values);
			if (validationRes.email) {
				// если есть ошибка
				return;
			}
			api
				.forgotPass(values, language)
				.then(() => {
					setSuccessfulSending(true);
					formik.resetForm();
					// navigate('/login')
				})
				.catch((err) => {
					console.log(err);
					setError(err);
				});
		},
	});

	function handleChange(e) {
		formik.handleChange(e);
		setSuccessfulSending(false);
	}

	return (<Layout location={props.location}>
			<Section title="">
				{successfulSending ? (<div
						className={"border border-green rounded-md w-full max-w-sm p-2 mb-5"}
					>
						<p className={"text-sm"}>{t("forgot_confirmation_email_sent")}</p>
					</div>) : ("")}
				<h3><Trans>Logi sisse</Trans></h3>
				{formik.errors.email ? (<ErrorMessage error={formik.errors.email}/>) : ("")}
				{error ? <ErrorMessage error={error}/> : ""}
				<form
					className={"w-full max-w-sm mt-10"}
					onSubmit={formik.handleSubmit}
				>
					<TextInput
						className="w-full"
						placeholder={t("forgot_form_username_placeholder")}
						id="email"
						name="email"
						type="email"
						size="lg"
						value={formik.values.email}
						onChange={handleChange}
						styles={{input: {"&:focus": {border: "1px solid #7AC142"}}}}
					/>
					<button
						className={"bg-green text-white w-full py-3 rounded-md mt-3 text-sm"}
						type="submit"
					>
						{t("forgot_form_submit_button")}
					</button>
				</form>
				<div
					className="flex flex-col md:flex-row items-center justify-between border-t  pt-8 mt-10 w-full text-sm">
					<p className={`max-w-sm text-center ${isRtl ? "md:text-right" : "md:text-left"}`}>
					<Trans>Dr Simeonsi dieedi tugikeskus mobiilirakendus on saadaval siin:</Trans>
					</p>
					<div className="flex">
						<a
							target={"_blank"}
							rel="noreferrer"
							href={"https://play.google.com/store/apps/details?id=com.shternconsulting.simeonsdiet.app"}
							className={`max-w-2xl w-full h-auto ${isRtl ? "ml-3" : "mr-3"}`}
						>
							<img src={appGoogleImg} alt="GooglePlay"/>
						</a>
						<a
							target={"_blank"}
							rel="noreferrer"
							href={"https://apps.apple.com/us/app/dr-simeonsi-dieedi-tugikeskus/id1435077850?ls=1"}
							className="max-w-2xl w-full h-auto m-0"
						>
							<img src={appStoreImg} alt="AppStore"/>
						</a>
					</div>
				</div>
			</Section>
		</Layout>);
};

export default Forgot;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;